import { TONE } from './constants'

const DAYS_PER_WEEK = 7
const MIDDAY_HOUR = 12

const getRelativeIsoDate = ({ days = 0, weeks = 0, months = 0 }) => {
  const date = new Date()
  date.setHours(MIDDAY_HOUR, 0, 0, 0)
  date.setDate(date.getDate() - days - weeks * DAYS_PER_WEEK)
  date.setMonth(date.getMonth() - months)
  return date.toISOString()
}

const daysAgo = (days) => getRelativeIsoDate({ days })
const weeksAgo = (weeks) => getRelativeIsoDate({ weeks })
const monthsAgo = (months) => getRelativeIsoDate({ months })

export const copilotConfigurationRows = [
  {
    key: 'semantic-index',
    setting: 'Semantic index rollout scope',
    current: 'Tenant default',
    recommended: 'Pilot group first',
  },
  { key: 'rss', setting: 'Restricted SharePoint Search', current: 'Not assessed', recommended: 'Enable for pilot' },
  { key: 'audit', setting: 'Copilot audit retention', current: 'Standard', recommended: 'Extend retention' },
]

export const sharePointExposureRows = [
  {
    key: 'executive-site',
    name: 'Executive Team',
    path: '/sites/executive',
    files: 148,
    sharing: 'Broad internal',
    tone: TONE.WARN,
    lastActivity: daysAgo(0),
  },
  {
    key: 'finance-site',
    name: 'Finance Operations',
    path: '/sites/finance',
    files: 37,
    sharing: 'Anonymous links',
    tone: TONE.DANGER,
    lastActivity: daysAgo(0),
  },
  {
    key: 'sales-site',
    name: 'Sales Enablement',
    path: '/sites/sales',
    files: 92,
    sharing: 'External guests',
    tone: TONE.WARN,
    lastActivity: daysAgo(1),
  },
]

export const oneDriveSharingRows = [
  {
    key: 'avery-drive',
    name: 'Avery Taylor',
    sub: 'Finance',
    anonFiles: 7,
    anonTone: TONE.WARN,
    externalShares: '12 links',
    lastShare: daysAgo(3),
  },
  {
    key: 'morgan-drive',
    name: 'Morgan Lee',
    sub: 'Operations',
    anonFiles: 3,
    anonTone: TONE.WARN,
    externalShares: '5 links',
    lastShare: daysAgo(9),
  },
  {
    key: 'jordan-drive',
    name: 'Jordan Smith',
    sub: 'Sales',
    anonFiles: 1,
    anonTone: TONE.WARN,
    externalShares: '2 links',
    lastShare: weeksAgo(3),
  },
]

export const siteLifecycleRows = [
  {
    key: 'legacy-projects',
    name: 'Legacy Projects',
    path: '/sites/legacy-projects',
    lastActivity: monthsAgo(18),
    items: 1240,
    signal: 'Stale site',
    signalTone: TONE.DANGER,
  },
  {
    key: 'vendor-dropbox',
    name: 'Vendor Dropbox',
    path: '/sites/vendor-dropbox',
    lastActivity: monthsAgo(14),
    items: 318,
    signal: 'Anonymous links',
    signalTone: TONE.WARN,
  },
  {
    key: 'archived-marketing',
    name: 'Archived Marketing',
    path: '/sites/archived-marketing',
    lastActivity: monthsAgo(13),
    items: 786,
    signal: 'Owner review',
    signalTone: TONE.WARN,
  },
]

export const dlpRows = [
  { key: 'financial', name: 'Financial data', workload: 'SharePoint, OneDrive', mode: 'Audit' },
  { key: 'pii', name: 'PII baseline', workload: 'Exchange, Teams', mode: 'Test' },
]

export const deviceRows = [
  {
    key: 'device-1',
    device: 'SURFACE-1824',
    user: 'Avery Taylor',
    os: 'Windows 10',
    issue: 'Non-compliant',
    tone: TONE.DANGER,
  },
  { key: 'device-2', device: 'MACBOOK-74', user: 'Morgan Lee', os: 'macOS', issue: 'Personal device', tone: TONE.WARN },
  {
    key: 'device-3',
    device: 'WIN11-552',
    user: 'Jordan Smith',
    os: 'Windows 11',
    issue: 'Encryption unknown',
    tone: TONE.WARN,
  },
]

export const shadowAiRows = [
  { key: 'chatgpt', label: 'ChatGPT', users: 42 },
  { key: 'claude', label: 'Claude', users: 25 },
  { key: 'perplexity', label: 'Perplexity', users: 13 },
]
